import {observable, action, runInAction} from 'mobx'
import {handleSeerchAndPage, setStore, ValueObjToObj} from "../../../../utils/Utils";
import {get,json} from "../../../../utils/ajax";
import {message} from "antd";

class EPCSparepartCatalogConfigStore {
    @observable modal //模态框
    @observable loading //加载
    @observable pagination //分页
    @observable list//主页面渲染所需数据
    @observable searchFields //查询所需数据
    @observable initSelectData//主页面数据
    @observable modifyData //修改页面数据
    @observable carseriesCode //点击修改时获取车系
    @observable isflag//点击修改时获取状态
    @observable groupId//点击修改时组id
    @observable carserData//点击修改时组id
    @observable initCarCode//选中的车系code
    @observable importReturnData
    @observable showDrawer
    @observable editFormArr
    @observable configLength //当前配置的长度，没有维护过的长度为0，已配置的取当前配置长度
    @observable initSelectList //下拉框数据
    @observable initSelectFirstList //下拉框数据
    @observable clickModelYearSet
    @observable showDrawerEdit
    @observable importReturnEditData
    @observable yearSet
    @observable rowIndex
    @observable editModal

    constructor(){
        this.modal=false
        this.loading=false
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper:true,
            showSizeChanger:true,
            pageSize:20,
            showTotal:()=>{}
        }
        this.list=[]
        this.searchFields={
            carserName:''
        }
        this.initSelectData={
            modelYearSet: [],
            powerSet: [],
            allocationSet: [],
            transTypeSet: [],
            driveTypeSet: [],
            emissionNormalSet: [],
        }
        this.modifyData={}
        this.editFormArr=[]
        this.carseriesCode=''
        this.isflag=''
        this.groupId=''
        this.carserData=[]
        this.initCarCode=''
        this.importReturnData=[]
        this.showDrawer = false
        this.configLength=0
        this.initSelectList=[]
        this.initSelectFirstList=[]
        this.clickModelYearSet=''
        this.showDrawerEdit = false
        this.importReturnEditData=[]
        this.yearSet=[]
        this.rowIndex=1
        this.editModal = false
    }

    /***
     * 页面数据绑到store
     * @param changedFields
     */
    @action
    onFormsChange = (changedFields) => {
        this.searchFields={...this.searchFields,...ValueObjToObj(changedFields)}
    }

    /***
     * 修改页面数据绑到store
     * @param changedFields
     */
    @action
    passValue = (changedFields) => {
        this.modifyData={...this.modifyData,...changedFields}
    }

    /***
     * 页面初始数据
     * @param page
     * @returns {Promise<void>}
     */
    @action
    initData=async (page)=>{
        // if(!this.searchFields.carserName){
        //     message.warning('请选择车系！')
        //     return
        // }
        this.loading=true
        //清除车系后值会变为将值变为空字符串
        if(this.searchFields.carserName === undefined){
            this.searchFields.carserName=''
        }
        if(this.searchFields.isFlag === undefined){
            this.searchFields.isFlag=''
        }
        let search = handleSeerchAndPage(page, this.pagination, this.searchFields)
        search.size = this.pagination.pageSize
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/groupCongig/queryAllByMapForPage`,search)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(()=>{
            this.list = res.content|| []
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper:true,
                showSizeChanger:true,
                pageSize:res.size,
                showTotal:()=>`总共 ${res.totalElements} 条`
            }
            this.loading=false
        })
    }

    /**
     * 设置store对象，类似react的setState
     * @param obj
     */
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    /***
     * 重置
     * @returns {Promise<void>}
     */
    @action
    clearSearch=async ()=>{
        this.searchFields={
            carserName:''
        }
        this.list=[]
        this.initCarCode=''
        this.pagination={
            current: 0,
            total: 1,
            showQuickJumper:true,
            showSizeChanger:true,
            pageSize:20,
            showTotal:()=>{}
        }
        await this.initData()
    }

    /***
     * 获取模态框回显数据
     * @param record
     * @returns {Promise<void>}
     */
    @action
    showModal=async (record)=>{
        this.configLength=0
        this.loading=true
        this.carseriesCode = record.carseriesCode
        this.isflag = record.isFlag
        this.groupId = record.id
        this.modifyData={}
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/groupCongig/queryConfigByGroupId/groupId/${this.groupId}`)
        runInAction(()=>{
            this.modalList=res
            this.modal=true
            //构建回显数据
            if(res.length===0){
                this.configLength =res.length+1
                let list=[]
                for(let i=0;i<res.length+1;i++){
                    list.push({
                        modelYearSet:`modelYearSet${i}`,
                        powerSet:`powerSet${i}`,
                        allocationSet:`allocationSet${i}`,
                        transTypeSet:`transTypeSet${i}`,
                        driveTypeSet:`driveTypeSet${i}`,
                        emissionNormalSet:`emissionNormalSet${i}`,
                    })
                    this.editFormArr=list//模态框显示的轨件到当前所有配置
                }
            }else{
                this.configLength =res.length
                let list=[]
                for(let i=0;i<res.length;i++){
                    list.push({
                        modelYearSet:`modelYearSet${i}`,
                        powerSet:`powerSet${i}`,
                        allocationSet:`allocationSet${i}`,
                        transTypeSet:`transTypeSet${i}`,
                        driveTypeSet:`driveTypeSet${i}`,
                        emissionNormalSet:`emissionNormalSet${i}`,
                    })
                }
                this.editFormArr=list//模态框显示的轨件到当前所有配置
            }
                //回显数据处理并赋值
            let arr =[]
            for(let i=0;i<res.length;i++){
                arr.push({
                    [`modelYearSet${i}`]:{value:res[i].modelYearSet},
                    [`powerSet${i}`]:{value:res[i].powerSet},
                    [`allocationSet${i}`]:{value:res[i].allocationSet},
                    [`transTypeSet${i}`]:{value:res[i].transTypeSet},
                    [`driveTypeSet${i}`]:{value:res[i].driveTypeSet},
                    [`emissionNormalSet${i}`]:{value:res[i].emissionNormalSet},
                })
                this.modifyData ={...this.modifyData, ...arr[i]}
            }
            this.modifyData={...this.modifyData}
            this.editModal = true
                this.loading=false
        })
    }

    /***
     * 点击修改获取车系下拉框数据
     * @returns {Promise<void>}
     */
    @action
    modifyYearSet=async()=>{
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/groupCongig/querySelectValues/carseriesCode?carseriesCode=${this.carseriesCode}`,{})
        runInAction(()=>{
            this.yearSet=[]
            for(let key in res){
                this.yearSet.push(key)
            }
        })
    }

    /**
     * 点击车系获取对应数据
     * @param key
     * @param index
     * @returns {Promise<void>}
     */
    @action
    initModifyFirstData=async(key,index)=>{
        let search = {}
        Object.keys(this.modifyData).forEach(item => {
            if(item.split('t').pop() === index.toString()){
                if(item.split(index)[0]==='modelYearSet'){
                    search[item.split(index)[0]]=[this.modifyData[item].value]
                }else {
                    search[item.split(index)[0]]=this.modifyData[item].value
                }
            }
        })
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/groupCongig/querySelectValues/carseriesCode?carseriesCode=${this.carseriesCode}`,search)
        runInAction(()=>{
            this.initSelectFirstList=[]
            for(let key in res){
                this.initSelectFirstList.push(key)
            }
        })
    }


    /***
     * 模态框选择上级数据时向后台请求新的下级数据
     * @returns {Promise<void>}
     */
    @action
    initModifyData=async(key,index)=>{
        let search = {}
        Object.keys(this.modifyData).forEach(item => {
            if(item.split('t').pop() === index.toString()){
                search[item.split(index)[0]]=this.modifyData[item].value
            }
        })
        if(typeof(search.modelYearSet)==="string"){
            search.modelYearSet=[search.modelYearSet]
        }
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/groupCongig/querySelectValues/carseriesCode?carseriesCode=${this.carseriesCode}`,search)
        runInAction(()=>{
            this.initSelectData=(Object.values(res))[0]
        })
    }

    /***
     * 点击修改获取车系下拉框数据
     * @returns {Promise<void>}
     */
    @action
    disabledData=async(key,index)=>{
        this.initSelectData={}
        if(this.modifyData[key]!==undefined){
            let search = {}
            Object.keys(this.modifyData).forEach(item => {
                if(item.split('t').pop() === index.toString()){
                    if(key.split(index)[0]==='powerSet'){
                        if(typeof(this.modifyData[`modelYearSet${index}`].value)==="string"){
                            search[`modelYearSet`]=[this.modifyData[`modelYearSet${index}`].value]
                        }else {
                            search[`modelYearSet`]=this.modifyData[`modelYearSet${index}`].value
                        }
                    }else if(key.split(index)[0]==='allocationSet') {
                        if(typeof(this.modifyData[`modelYearSet${index}`].value)==="string"){
                            search[`modelYearSet`]=[this.modifyData[`modelYearSet${index}`].value]
                        }else {
                            search[`modelYearSet`]=this.modifyData[`modelYearSet${index}`].value
                        }
                        search[`powerSet`]=this.modifyData[`powerSet${index}`].value
                    }else if(key.split(index)[0]==='transTypeSet') {
                        if(typeof(this.modifyData[`modelYearSet${index}`].value)==="string"){
                            search[`modelYearSet`]=[this.modifyData[`modelYearSet${index}`].value]
                        }else {
                            search[`modelYearSet`]=this.modifyData[`modelYearSet${index}`].value
                        }
                        search[`powerSet`]=this.modifyData[`powerSet${index}`].value
                        search[`allocationSet`]=this.modifyData[`allocationSet${index}`].value
                    }else if(key.split(index)[0]==='driveTypeSet') {
                        if(typeof(this.modifyData[`modelYearSet${index}`].value)==="string"){
                            search[`modelYearSet`]=[this.modifyData[`modelYearSet${index}`].value]
                        }else {
                            search[`modelYearSet`]=this.modifyData[`modelYearSet${index}`].value
                        }
                        search[`powerSet`]=this.modifyData[`powerSet${index}`].value
                        search[`allocationSet`]=this.modifyData[`allocationSet${index}`].value
                        search[`transTypeSet`]=this.modifyData[`transTypeSet${index}`].value
                    }else if(key.split(index)[0]==='emissionNormalSet') {
                        if(typeof(this.modifyData[`modelYearSet${index}`].value)==="string"){
                            search[`modelYearSet`]=[this.modifyData[`modelYearSet${index}`].value]
                        }else {
                            search[`modelYearSet`]=this.modifyData[`modelYearSet${index}`].value
                        }
                        search[`powerSet`]=this.modifyData[`powerSet${index}`].value
                        search[`allocationSet`]=this.modifyData[`allocationSet${index}`].value
                        search[`transTypeSet`]=this.modifyData[`transTypeSet${index}`].value
                        search[`driveTypeSet`]=this.modifyData[`driveTypeSet${index}`].value
                    }
                }
            })
            const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/groupCongig/querySelectValues/carseriesCode?carseriesCode=${this.carseriesCode}`,search)
            runInAction(()=>{
                this.initSelectData=(Object.values(res))[0]
            })
        }else {
            let search={}
            search[`modelYearSet`]=this.modifyData[`modelYearSet${index}`]&&[this.modifyData[`modelYearSet${index}`].value]
            if(!search[`modelYearSet`]){
                this.initSelectData={}
            }else {
                Object.keys(this.modifyData).forEach(item => {
                    if(item.split('t').pop() === index.toString()){
                        if(item.split(index)[0]==='modelYearSet'){
                            search[item.split(index)[0]]=[this.modifyData[item].value]
                        }else {
                            search[item.split(index)[0]]=this.modifyData[item].value
                        }
                    }
                })
                search[`modelYearSet`]=this.modifyData[`modelYearSet${index}`]&&[this.modifyData[`modelYearSet${index}`].value]
                const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/groupCongig/querySelectValues/carseriesCode?carseriesCode=${this.carseriesCode}`,search)
                runInAction(()=>{
                    this.initSelectData=(Object.values(res))[0]
                })
            }

        }
    }

    /**
     * 选上级时清空下级  row当前选择的第几行，line 当前选择的第几列配置索引
     * @param index
     */
    @action
    clearForm = (row, index) => {
        let list = Object.keys(this.modifyData)
        let arr = []
        list.forEach(item => {
            if (item.split('t').pop() === index.toString()) {
                arr.push(item)
            }
        })
        list.forEach((item,i)=>{
            if(((i%6) > row) && (arr.includes(item))){
                this.modifyData[item]={value:[]}
            }
        })
    }

    /**
     * 隐藏模态框
     */
    @action
    hideModal=()=>{
        this.modal=false
        this.modifyData={}
        this.editModal = false
        this.initSelectData={}
    }

    /***
     * 修改保存
     * @returns {Promise<void>}
     */
    @action
    saveModifyData=async ()=>{
        let list =[]
        for(let i=0;i<this.editFormArr.length+1;i++) {
            if (typeof (this.modifyData[`modelYearSet${i}`] && this.modifyData[`modelYearSet${i}`].value) === "string") {
                this.modifyData[`modelYearSet${i}`].value = [this.modifyData[`modelYearSet${i}`].value]
            }
            list.push({
                modelYearSet: this.modifyData[`modelYearSet${i}`] && this.modifyData[`modelYearSet${i}`].value,
                powerSet: this.modifyData[`powerSet${i}`] && this.modifyData[`powerSet${i}`].value,
                allocationSet: this.modifyData[`allocationSet${i}`] && this.modifyData[`allocationSet${i}`].value,
                transTypeSet: this.modifyData[`transTypeSet${i}`] && this.modifyData[`transTypeSet${i}`].value,
                driveTypeSet: this.modifyData[`driveTypeSet${i}`] && this.modifyData[`driveTypeSet${i}`].value,
                emissionNormalSet: this.modifyData[`emissionNormalSet${i}`] && this.modifyData[`emissionNormalSet${i}`].value
            })
        }
            const res =  await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/groupCongig/updateConfigByGroupId/carseriesCode?carseriesCode=${this.carseriesCode}&&groupId=${this.groupId}&&isflag=${this.isflag}`,list)
            runInAction(()=>{
                if(res.code==='success'){
                    if(!res.data){
                        message.info(res.data)
                    }else {
                        message.success('修改成功')
                    }
                    this.onShow(res.data.msg)
                }
                this.modal=false
                this.initSelectData={}
                this.editModal = false
                this.initData(this.pagination.current)
            })
    }

    /***
     * 获取车系下拉框数据
     * @returns {Promise<void>}
     */
    @action
    editCarserData=async ()=>{
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carseriesCatalog/queryCarListByContent`)
        runInAction(()=>{
            this.carserData = Array.isArray(res) ? res : []
        })
    }

    /**
     * 获取下拉车系code
     * @param value
     */
    @action
    changeCarseriesValue=(value)=>{
        let initCarData=this.carserData.find(item=>item.carseriesName === value)
        this.initCarCode = initCarData&&initCarData.carSeriesCode
    }

    /**
     * 导入
     * @param arr
     */
    @action
    onUpload=(arr)=>{
        this.importReturnData = arr
        this.showDrawer=true
    }

    /***
     * 关闭抽屉
     */
    @action
    onClose=()=>{
        this.showDrawer=false
    }

    /**
     * 在修改模态框中新增配置
     */
    @action
    modifyAddForm=()=>{
        this.loading=true
        // 新增表单
        this.editFormArr.push({
            modelYearSet:`modelYearSet${this.configLength}`,
            powerSet:`powerSet${this.configLength}`,
            allocationSet:`allocationSet${this.configLength}`,
            transTypeSet:`transTypeSet${this.configLength}`,
            driveTypeSet:`driveTypeSet${this.configLength}`,
            emissionNormalSet:`emissionNormalSet${this.configLength}`
        })
        this.configLength=this.configLength+1
        this.loading=false
    }

    /**删除当前点击行**/
    @action
    removeRows = (index) => {
        this.rowIndex=index
        this.loading=true
        this.configLength=this.configLength-1
        let arr = [...this.editFormArr]
        arr.splice(index, 1)
        //重构表单
        let editFormArr=[]
        for(let i=0;i<arr.length;i++){
            editFormArr.push({
                modelYearSet:`modelYearSet${i}`,
                powerSet:`powerSet${i}`,
                allocationSet:`allocationSet${i}`,
                transTypeSet:`transTypeSet${i}`,
                driveTypeSet:`driveTypeSet${i}`,
                emissionNormalSet:`emissionNormalSet${i}`,
            })
        }
        this.editFormArr=editFormArr
        // this.editFormArr=arr
        //回显数据处理并赋值
        let obj ={...this.modifyData}
        for(let key in obj){
            if(String(index)===key.split('t').pop()){
                delete obj[key]
            }
        }
        let list =[]
        for(let i=0;i<this.editFormArr.length+1;i++) {
            if(obj[`modelYearSet${i}`]){
                if (typeof (obj[`modelYearSet${i}`] && obj[`modelYearSet${i}`].value) === "string") {
                    obj[`modelYearSet${i}`].value = [obj[`modelYearSet${i}`].value]
                }
                list.push({
                    modelYearSet: obj[`modelYearSet${i}`] && obj[`modelYearSet${i}`].value,
                    powerSet: obj[`powerSet${i}`] && obj[`powerSet${i}`].value,
                    allocationSet: obj[`allocationSet${i}`] && obj[`allocationSet${i}`].value,
                    transTypeSet: obj[`transTypeSet${i}`] && obj[`transTypeSet${i}`].value,
                    driveTypeSet: obj[`driveTypeSet${i}`] && obj[`driveTypeSet${i}`].value,
                    emissionNormalSet: obj[`emissionNormalSet${i}`] && obj[`emissionNormalSet${i}`].value
                })
            }
        }
        let modifyData ={}
        for (let [key, value] of Object.entries(list)) {
            modifyData[`modelYearSet${key}`]={value:value.modelYearSet}
            modifyData[`powerSet${key}`]={value:value.powerSet}
            modifyData[`allocationSet${key}`]={value:value.allocationSet}
            modifyData[`transTypeSet${key}`]={value:value.transTypeSet}
            modifyData[`driveTypeSet${key}`]={value:value.driveTypeSet}
            modifyData[`emissionNormalSet${key}`]={value:value.emissionNormalSet}

        }
        this.modifyData={...modifyData}
        this.loading=false
    }


    @action
    onShow=(arr)=>{
        this.importReturnEditData = arr
        this.showDrawerEdit=true
    }

    /***
     * 关闭抽屉
     */
    @action
    onCloseEdit=()=>{
        this.showDrawerEdit=false
    }


}
export default new EPCSparepartCatalogConfigStore()



// WEBPACK FOOTER //
// ./src/Backend/sparePartsCatalogue/EPC/EPCSparepartCatalogConfig/store.js